import { render, staticRenderFns } from "./PlayerBanLink.vue?vue&type=template&id=7c5eb87d&"
import script from "./PlayerBanLink.vue?vue&type=script&lang=js&"
export * from "./PlayerBanLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports